import { api } from 'data/api/api'

import { GetShipmentItemsResp } from '../types/shipment-items'

export const getShipmentItems = (transactionId: number) =>
  api.get<GetShipmentItemsResp>(`/transactions/${transactionId}/shipment/items`)
